import Vue from "vue";
import Vuex from "vuex";
import moment from "moment";
import api from "../api/";
import createLogger from "vuex/dist/logger";
import createPersistedState from "vuex-persistedstate";
import * as actions from "./actions";
import * as mutations from "./mutations";

//Vuex modules
import report from "./modules/report";
import provider from "./modules/provider";
import main from "./modules/main";
import adminTools from "./modules/admin-tools";
import user from "./modules/user";
import chart from "./modules/chart";
import partner from "./modules/partner";

Vue.use(Vuex);
import { AbilityBuilder } from "@casl/ability";

function subjectName(item) {
  if (!item || typeof item === "string") {
    return item;
  }

  return item.__type;
}
let defaultAbility = AbilityBuilder.define({ subjectName }, (can, cannot) => {
  can("read", "login");
  cannot(["create", "read", "update", "delete"], "all");
});

let state = {
  loading: false,
  requests: 0,
  login: "",
  authenticated: false,
  tokenExpire: null,
  token: "",
  userGuid: "",
  role: "",
  error: {},
  permissions: [],
  abilities: defaultAbility.rules,
  degaultRules: defaultAbility.rules,
  onlineStaff: [],
  transactionsQueue: []
};
var store;
export default (store = new Vuex.Store({
  actions,
  mutations,
  state,
  getters: {
    loading(state) {
      return !!state.loading;
    }
  },
  modules: { report, main, provider, adminTools, user, chart, partner },
  plugins: [
    createLogger(),
    createPersistedState({ key: "v1.1.11", paths: [] }),
    store => {
      api.on("logout", () => {
        store.dispatch("logout");
      });
      api.on("loading", () => {
        store.commit("setLoading", true);
      });
      api.on("loaded", () => {
        store.commit("setLoading", false);
      });
      api.on("message", event => {
        try {
          let data = JSON.parse(event.data);
          store.commit(data.type, data.data);
        } catch (err) {
          console.log("Message error ", event);
        }
      });
      setInterval(api.health.bind(api), 10000);
      api.on("error", err => {
        console.log("api.on(error)", err);
        store.commit("setError", {
          statusCode: err.status,
          ...err.data
        });
      });
      store.subscribe(mutation => {
        switch (mutation.type) {
          case "setToken":
            api.setToken(mutation.payload);
            break;
        }
      });
      api.setToken(store.state.token);
    }
  ]
}));



// WEBPACK FOOTER //
// ./src/store/index.js